import { Rating, Skeleton } from "@mui/material";
import { ApiRequest } from "GlobalFunctions";
import { useEffect, useState } from "react";
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';

export default function Ratings(props: any) {
    const { user_id } = props;
    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState(true);

    const loadDetails = async () => {
        setLoading(true);
        await ApiRequest({
            url: '/ratings/lastRatings',
            method: 'GET',
            query: { user_id },
            setResponse: (response: any) => {
                setData(response.list || []);
                setLoading(false);
            }
        });
    }

    useEffect(() => {
        if (user_id) loadDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user_id]);

    /*  data example
    [
    {
        "rating_id": 15,
        "rated_user_id": 1,
        "rated_by_user_id": 2,
        "rating_value": 3,
        "comment": "Buen servicio, pero podría mejorar el tiempo de respuesta",
        "rating_date": "2024-10-03T05:00:00.000Z"
    },
    {
        "rating_id": 14,
        "rated_user_id": 1,
        "rated_by_user_id": 2,
        "rating_value": 5,
        "comment": "Excelentes habilidades y muy recomendado",
        "rating_date": "2024-10-02T05:00:00.000Z"
    },
    {
        "rating_id": 13,
        "rated_user_id": 1,
        "rated_by_user_id": 2,
        "rating_value": 4,
        "comment": "Servicio muy profesional y amable",
        "rating_date": "2024-10-01T05:00:00.000Z"
    }
]
    */
    
    if (loading) return (
        <div style={{ marginTop: '32px' }}>
            <Skeleton variant="text" width={120} height={36} sx={{ mb: 1 }} />
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
                {[1, 2].map(i => <Skeleton key={i} variant="rounded" height={120} />)}
            </div>
        </div>
    );

    return (
        <div style={{ marginTop: '32px' }}>
            <h2 className='titles'>Reseñas</h2>

            {data.length === 0 ? (
                <p style={{ color: '#aaa', fontStyle: 'italic' }}>Esta enfermera aún no tiene reseñas.</p>
            ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px', marginTop: '16px' }}>
                    {data.map((item: any, index: number) => {
                        const initials = `${(item.name || '?')[0]}${(item.lastname || '')[0] || ''}`.toUpperCase();
                        const dateStr = item.rating_date
                            ? new Date(item.rating_date).toLocaleDateString('es-CL', { year: 'numeric', month: 'short', day: 'numeric' })
                            : '';
                        return (
                            <div key={index} style={{
                                background: '#fff',
                                borderRadius: '12px',
                                padding: '20px',
                                boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '12px',
                                border: '1px solid #f0f0f0'
                            }}>
                                <Rating
                                    value={item.rating_value}
                                    readOnly
                                    precision={0.5}
                                    size="small"
                                    icon={<StarRateRoundedIcon fontSize="inherit" />}
                                    emptyIcon={<StarRateRoundedIcon style={{ opacity: 0.3 }} fontSize="inherit" />}
                                />
                                {item.comment && (
                                    <p style={{ margin: 0, fontSize: '14px', color: '#444', lineHeight: '1.6', flex: 1 }}>
                                        "{item.comment}"
                                    </p>
                                )}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: 'auto' }}>
                                    <div style={{
                                        width: '36px', height: '36px', borderRadius: '50%',
                                        background: '#135095', color: '#fff',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontSize: '13px', fontWeight: 600, flexShrink: 0
                                    }}>
                                        {initials}
                                    </div>
                                    <div>
                                        <div style={{ fontSize: '13px', fontWeight: 600, color: '#222' }}>
                                            {item.name} {item.lastname}
                                        </div>
                                        {dateStr && (
                                            <div style={{ fontSize: '11px', color: '#aaa' }}>{dateStr}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    )
}